import { tv, type VariantProps } from 'tailwind-variants';
export type OrNavBarVariants = VariantProps<typeof orNavBarVariants>;

const orNavBarVariants = tv({
  base: 'paragraph-lg w-auto fixed left-0 right-0 z-[11] box-border transition-colors md:py-2.5 lg:mx-auto lg:!px-7',
  slots: {
    topNav:
      'relative col-span-4 flex h-full min-h-62 flex-row items-center justify-between pl-1.75 pr-2 md:grid md:grid-cols-3 lg:px-0 ml-0',
  },
  variants: {
    isToggled: {
      true: {
        base: 'top-0 h-dvh overflow-hidden transition-none md:overflow-auto',
      },
    },
  },
  compoundVariants: [],
});

export default orNavBarVariants;
